import React from 'react';
import { Title } from '../../importCL';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './AddressInvalidModal.css';

interface IAddressInvalidModal {
    headline?: string;
    invalidAddress?: string;
    closeCallback?: () => void;
}

function AddressInvalidModal({
    headline,
    invalidAddress,
    closeCallback,
}: IAddressInvalidModal) {
    return (
        <div
            className='AddressInvalidModal__popUpContainer'
            onClick={closeCallback}>
            <div
                className='AddressInvalidModal__popUpContent'
                onClick={(e) => e.stopPropagation()}>
                <Title
                    className='AddressInvalidModal__popUpClose'
                    onClick={closeCallback}>×</Title>

                <Title
                    className='AddressInvalidModal__popUpHeadline text-center'
                    tag='h5'
                >
                    {transformHTMLParserLinks(headline || '')}
                </Title>
                <p className='AddressInvalidModal__popUpSubHeadline'>
					{transformHTMLParserLinks(invalidAddress)}
				</p>
            </div>
        </div>
    );
}

export default AddressInvalidModal;